import { Fragment } from 'react'
import { Box, Button, ImageList, ImageListItem, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { ID } from '../types/models'
import { TopTitle } from '../components/atoms/TopTitle'
import { useDevices } from '../hooks/useDevices'

export function DevicePage(): React.ReactElement {

  const params = useParams()
  const { id } = params
  const navigate = useNavigate()

  const { control } = useDevices()
  const devices = control.controls({ deviceId: parseInt(id || '0') as ID })

  return (
    <Fragment>
      <TopTitle title="Device"/>
      {
        id && devices.length &&
          <Box>
            <Typography variant="h2" sx={{ color: '#fff' }}>[{devices[0].device.hw_id}] {devices[0].device.device_spec?.manufacturer} {devices[0].device.device_spec?.model}</Typography>
            <ImageList cols={3}>
              <ImageListItem>
                <img src={`/api/v1/device-specs/${devices[0].device.device_spec?.id}/picture`} alt="Device"/>
              </ImageListItem>
            </ImageList>
            <Button onClick={() => navigate(`/config/${id}`)}>Gonfigure</Button>
          </Box>
      }
    </Fragment>
  )
}
